import React, { useState } from 'react';
import AttendanceTracker from './AttendanceTracker.jsx';
import AttendanceDashboard from './AttendanceDashboard.jsx';

// Department heads land on their own attendance screen (like employees)
// and can switch to the full team dashboard with a button.
const MyAttendanceWithTeam = () => {
  const [showTeam, setShowTeam] = useState(false);

  return showTeam
    ? <AttendanceDashboard onBack={() => setShowTeam(false)} />
    : <AttendanceTracker onViewTeam={() => setShowTeam(true)} />;
};

export default MyAttendanceWithTeam;
